import { LlmModelTypesEnum, LlmModelTypesLookup } from '@eluve/graphql-types';

export const SCHEMA_VALIDATION_MODELS: Array<{
  name: string;
  modelType: LlmModelTypesEnum;
  modelId: string;
}> = [
  // OpenAI models
  {
    name: 'GPT-4.1',
    modelType: LlmModelTypesLookup.GPT_4_O,
    modelId: 'gpt-4.1',
  },
  {
    name: 'GPT-5',
    modelType: LlmModelTypesLookup.GPT_4_O,
    modelId: 'gpt-5',
  },
  {
    name: 'GPT-5 Pro',
    modelType: LlmModelTypesLookup.GPT_4_O,
    modelId: 'gpt-5-pro',
  },
  {
    name: 'GPT-5.2',
    modelType: LlmModelTypesLookup.GPT_4_O,
    modelId: 'gpt-5.2',
  },
  {
    name: 'GPT-5.4',
    modelType: LlmModelTypesLookup.GPT_5,
    modelId: 'gpt-5.4',
  },
  {
    name: 'GPT-5.4 Mini',
    modelType: LlmModelTypesLookup.GPT_5,
    modelId: 'gpt-5.4-mini',
  },
  // Anthropic models
  {
    name: 'Claude 4.5 Sonnet',
    modelType: LlmModelTypesLookup.CLAUDE_4_5,
    modelId: 'claude-sonnet-4-5-20250929',
  },
  {
    name: 'Claude 4.5 Opus',
    modelType: LlmModelTypesLookup.CLAUDE_4_5,
    modelId: 'claude-opus-4-5-20251101',
  },
  {
    name: 'Claude 4.6 Opus',
    modelType: LlmModelTypesLookup.CLAUDE_4_6,
    modelId: 'claude-opus-4-6',
  },
  {
    name: 'Claude 4.6 Sonnet',
    modelType: LlmModelTypesLookup.CLAUDE_4_6,
    modelId: 'claude-sonnet-4-6',
  },
  // Groq models
  {
    name: 'Groq GPT-OSS 120B',
    modelType: LlmModelTypesLookup.GROQ,
    modelId: 'openai/gpt-oss-120b',
  },
  // Lightning AI models
  {
    name: 'Lightning Gemma 4 31B',
    modelType: LlmModelTypesLookup.LIGHTNING_AI,
    modelId: 'lightning-ai/gemma-4-31B-it',
  },
  // Google Gemini models
  {
    name: 'Gemini 2.5 Pro',
    modelType: LlmModelTypesLookup.GEMINI,
    modelId: 'gemini-2.5-pro',
  },
  {
    name: 'Gemini 3.1 Pro',
    modelType: LlmModelTypesLookup.GEMINI,
    modelId: 'gemini-3.1-pro-preview',
  },
];
